'use strict';

var Promise = require('bluebird');
var loadMustache = require('../loadMustache');
const cdn = (window.wooGlobal.settings.cdn !== null) ? window.wooGlobal.settings.cdn : '/';

function loadMarketingMustaches (isAdvanced) {
  var mustachesToLoad = [{
    name: 'marketingTasks',
    url: cdn + 'assets/mustache/tasks/marketing-tasks.mustache?v=4'
  }];

  if (isAdvanced) {
    mustachesToLoad.push({
      name: 'marketingTasksFilter',
      url: cdn + 'assets/mustache/tasks/marketing-tasks-filters.mustache?v=4'
    });
  }

  return Promise.map(mustachesToLoad, function (mustacheDefinition) {
    return loadMustache(mustacheDefinition.url)
      .then(function (template) {
        return {
          name: mustacheDefinition.name,
          template: template
        };
      });
  })
    .then(function (mustaches) {
      return mustaches.reduce(function (mustachesMap, mustache) {
        mustachesMap[mustache.name] = mustache.template;

        return mustachesMap;
      }, {});
    });
}

module.exports = loadMarketingMustaches;
